import React from 'react'
import PropTypes from 'prop-types'
import { Dots } from '@ynap/animations'
import BEMHelper from '@ynap/bem-helper'

const bem = new BEMHelper('Loading')

const Loading = ({ message, className }) => (
    <div className={bem('loading', null, className)}>
        <Dots className={bem('loading-content')} type={'secondary'}>
            <div className={bem('loading-text')}>{message}</div>
        </Dots>
    </div>
)

Loading.propTypes = {
    message: PropTypes.string.isRequired,
    className: PropTypes.string,
}

export default Loading
